import Core from "@/modules/core/service/Core";

export default {
    props: {
        unitId: {

        },
    },

    data: () => ({
        readonly: true,
    }),

    computed: {
        contractValid () {
            return this.contract && this.contract.id !== 0;
        }
    },

    methods: {
        onReadonly (readonly) {
            this.readonly = readonly;
        },

        moneyAsString (value) {
            return Core.format.money(value);
        }
    }
}